export default "__VITE_ASSET__DmjOXoff__"